/**
 * Created by lihanying on 2017/7/6.
 */

export const GETPAYMENTLIST = 'GETPAYMENTLIST'
export const GETBUSINESS = 'GETBUSINESS'
export const GETPERIOD = 'GETPERIOD'
export const GETRECORDDETAIL = 'GETRECORDDETAIL'


// WEBPACK FOOTER //
// ./src/containers/Consume/constants.js